import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { JwtResponse } from 'src/app/interfaces/jwt';


@Injectable({
  providedIn: 'root'
})
export class AuthGuardGuard implements CanActivate {


  usuario: JwtResponse;

  usuarioRol: string;

  constructor(private router: Router,
  ) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    this.usuario =  JSON.parse(localStorage.getItem('currentUser'));

    if(this.usuario == null){
      this.router.navigate(['/acceder'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    // Empresa that hasn't completed profile → wizard
    if (this.usuario.role === 'empresa' && this.usuario.user?.perfilCompleto === false) {
      if (state.url !== '/completar-empresa') {
        this.router.navigate(['/completar-empresa']);
      }
      return state.url === '/completar-empresa';
    }

    if(this.usuario.user.verificado == false){
      this.router.navigate(['/editar-perfil']);
      window.addEventListener('beforeunload', (event) => {
        event.preventDefault();
        event.returnValue = 'Rellena Los Campos Especificados para continuar';
      });
      return false;
    }

    if(this.usuario.user.verificado == true || this.usuario.user.verificado == null){
      return true;
    }

    return false;

}
}
